module.exports = __webpack_public_path__ + "media/images/lb/697-96003beca1015e87a16c736de8ae3b00.svg";